import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { styled } from 'styled-components';
import { headerDropContext } from '@/js/libs/ui/src/Components/Table/PositionsGroup/DndContext';
import { Media } from '../../../theme/Media';
import { useTableContext } from '../context';
import TbodySeparator from '../TbodySeparator';
import Td from '../Td';
import Tr from '../Tr';
export const Header = styled.tbody `
  + tbody > tr:first-child > td {
    @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
      border-top: 2px solid ${({ theme }) => theme.colors.grey30_1};
    }
  }
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.mdMax : Media.lgMax)} {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > tr {
      width: 100%;
      margin: 0 0 -3px;
    }
  }
`;
export const Content = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;
export const Title = styled.div `
  padding: 5px 14px;
  background: ${({ theme }) => theme.colors.grey30_1};
  border-radius: 4px 4px 0 0;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
`;
const TitleGroup = styled.div `
  display: flex;
  gap: 5px;
  align-items: center;
`;
export const Summary = styled.div `
  font-weight: 500;
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    padding: 0 14px;
  }
`;
export const RightSide = styled.div `
  display: flex;
  align-items: center;
`;
const TbodyHeader = ({ name, nameAdditional, summary, actions, dataTestId }) => {
    const { isCollapsedNav } = useTableContext();
    const header = React.useContext(headerDropContext);
    return (_jsxs(_Fragment, { children: [_jsx(TbodySeparator, {}), _jsx(Header, { ref: header, "$isCollapsedNav": isCollapsedNav, children: _jsx(Tr, { children: _jsx(Td, { type: 'sub', bgColor: 'transparent', children: _jsxs(Content, { children: [_jsxs(TitleGroup, { children: [_jsx(Title, { "data-testid": dataTestId, children: name }), nameAdditional] }), (summary || actions) && (_jsxs(RightSide, { children: [summary && _jsx(Summary, { "$isCollapsedNav": isCollapsedNav, children: summary }), actions] }))] }) }) }) })] }));
};
export default TbodyHeader;
